import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  description: string;
  action?: React.ReactNode;
}

export default function SettingsPageHeader({ description, action }: Props) {
  return (
    <Box
      sx={(t) => ({
        mb: 2,
        pb: 1.5,
        borderBottom: `1px solid ${t.tokens.border.subtle}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 2,
        flexWrap: 'wrap',
      })}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: '0.8125rem', lineHeight: 1.45 }}
      >
        {description}
      </Typography>
      {action}
    </Box>
  );
}
